import type { ReactNode } from 'react';
import { cn } from '../../lib/utils';

export type BubbleActionColor = 'indigo' | 'purple' | 'blue' | 'teal' | 'amber';

const COLOR_STYLES: Record<BubbleActionColor, string> = {
  indigo:
    'border-status-accent-indigo/30 bg-status-accent-indigo/10 text-status-accent-indigo hover:bg-status-accent-indigo/20',
  purple:
    'border-status-accent-purple/30 bg-status-accent-purple/10 text-status-accent-purple hover:bg-status-accent-purple/20',
  blue: 'border-status-info/30 bg-status-info/10 text-status-info hover:bg-status-info/20',
  teal: 'border-status-accent-teal/30 bg-status-accent-teal/10 text-status-accent-teal hover:bg-status-accent-teal/20',
  amber:
    'border-status-warning/30 bg-status-warning/10 text-status-warning hover:bg-status-warning/20',
};

const BASE =
  'mt-2 inline-flex items-center gap-1.5 rounded-md border px-3 py-1.5 text-xs font-medium transition-colors';

export interface BubbleActionLinkProps {
  color: BubbleActionColor;
  href?: string;
  onClick?: () => void;
  children?: ReactNode;
  className?: string;
}

export function BubbleActionLink({
  color,
  href,
  onClick,
  children,
  className,
}: BubbleActionLinkProps) {
  const classes = cn(BASE, COLOR_STYLES[color], className);

  if (href) {
    return (
      <a href={href} target="_blank" rel="noopener noreferrer" className={classes}>
        {children}
      </a>
    );
  }

  return (
    <button type="button" onClick={onClick} className={classes}>
      {children}
    </button>
  );
}
